module.exports = __webpack_public_path__ + "img/e8d617f.jpg";